import React from "react";
import { Button } from "@/components/ui/button";
import { Edit } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { MessageGuestButton } from "@/components/pages/chats/component/MessageGuestButton";

export const ActionsCell = ({
  id,
  showEditAction = true,
}: {
  id: string;
  showEditAction?: boolean;
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center gap-2">
      <MessageGuestButton bookingId={id} />
      {showEditAction && (
        <Button
          variant="ghost"
          size="sm"
          className="h-8 w-8 p-0"
          onClick={(e) => {
            e.stopPropagation();
            navigate(`/reservations/${id}?edit=true`);
          }}
        >
          <Edit className="h-4 w-4 text-gray-600" />
        </Button>
      )}
    </div>
  );
};
